import { render, staticRenderFns } from "./companyVideoUrl.vue?vue&type=template&id=72fb1edc&scoped=true"
import script from "./companyVideoUrl.vue?vue&type=script&lang=js"
export * from "./companyVideoUrl.vue?vue&type=script&lang=js"
import style0 from "./companyVideoUrl.vue?vue&type=style&index=0&id=72fb1edc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb1edc",
  null
  
)

export default component.exports